export default __webpack_public_path__ + "static/media/payssamlogo.e442fd4f.svg";